import { useState, useEffect } from "react";
import { motion } from "framer-motion";

export const LiveTranscript = ({
  lines,
  interval = 1900,
  aiClass = "text-white",
  callerClass = "text-neutral-400",
  labelMutedClass = "text-neutral-500",
  className = "",
}) => {
  const [visible, setVisible] = useState(1);
  useEffect(() => {
    const id = setInterval(() => {
      setVisible((v) => (v >= lines.length ? 1 : v + 1));
    }, interval);
    return () => clearInterval(id);
  }, [lines.length, interval]);

  return (
    <div className={`font-mono-t text-[13px] leading-relaxed space-y-2 ${className}`} data-testid="live-transcript">
      {lines.slice(0, visible).map((line, i) => (
        <motion.div
          key={i}
          initial={{ opacity: 0, y: 8 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.4 }}
          className="flex gap-3"
        >
          <span className={`shrink-0 uppercase text-[10px] tracking-widest pt-[3px] ${line.who === "AI" ? aiClass : labelMutedClass}`}>
            {line.who}
          </span>
          <p className={line.who === "AI" ? aiClass : callerClass}>{line.text}</p>
        </motion.div>
      ))}
    </div>
  );
};
